import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M6 7h2v2H6zM6 11h2v2H6zM6 15h2v2H6z',
    'M15.5 19H11V5h4.5a.5.5 0 0 0 0-1H3.4851A.485.485 0 0 0 3 4.485V19.515A.485.485 0 0 0 3.4851 20H15.5a.5.5 0 0 0 0-1zM10 19H4V5h6v14z',
    'M18.8799 11.6748l-3-3.5c-.1807-.21-.497-.2334-.7051-.0542a.4993.4993 0 0 0-.0547.7046L17.8418 12l-2.7217 3.1748a.5.5 0 0 0 .0547.705c.0938.0811.21.1202.3252.1202a.5011.5011 0 0 0 .3799-.1748l3-3.5a.5003.5003 0 0 0 0-.6504z',
  ],
  height: 24,
  width: 24,
});
